import * as Sentry from "@sentry/react";
import { AxiosError } from "axios";

import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import { BusinessError, NetworkError } from "./utils/error";

// 动态模块加载错误的特征
export const isDynamicImportError = (error: Error) => {
  return (
    error instanceof TypeError &&
    error.message.includes("Failed to fetch dynamically imported module")
  );
};

Sentry.init({
  dsn: "https://9fc433c734f7e3707bbb70333d805822@o4508466046763008.ingest.us.sentry.io/4508466051153920",
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event, hint) {
    const error = hint?.originalException;

    // 检查是否是网络请求错误
    if (
      (error instanceof Error && error.message.includes("Network Error")) ||
      error instanceof BusinessError ||
      error instanceof NetworkError
    ) {
      return null; // 返回 null 阻止上报
    }

    if (error instanceof AxiosError) {
      return null;
    }

    if (error instanceof Error && isDynamicImportError(error)) {
      return null;
    }

    return event; // 返回事件则允许上报
  },
});
